var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeWcPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 12C7.49999 10.5166 7.93986 9.0666 8.76397 7.83323C9.58808 6.59986 10.7594 5.63856 12.1299 5.07091C13.5003 4.50325 15.0083 4.35472 16.4632 4.64411C17.918 4.9335 19.2544 5.64781 20.3033 6.6967C21.3522 7.7456 22.0665 9.08197 22.3559 10.5368C22.6453 11.9917 22.4967 13.4997 21.9291 14.8701C21.3614 16.2406 20.4001 17.4119 19.1668 18.236C17.9334 19.0601 16.4834 19.5 15 19.5H6.74999C6.00558 19.4991 5.26987 19.3399 4.59169 19.0329C3.91351 18.726 3.30835 18.2783 2.81639 17.7196C2.32442 17.1609 1.95689 16.504 1.73817 15.7925C1.51946 15.0809 1.45457 14.331 1.54781 13.5924C1.64105 12.8539 1.89029 12.1436 2.27899 11.5087C2.66768 10.8738 3.18695 10.3289 3.80233 9.91001C4.41771 9.49114 5.11513 9.20792 5.84832 9.07915C6.58152 8.95038 7.33371 8.97901 8.05499 9.16313",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 14.8125H10.5938H8.34375",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8438 14.8125H16.5938",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9688 11.3438H11.7188",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeWcPurple);
export default __webpack_public_path__ + "static/media/question_type_wc_purple.7d39bfbba46da50e3a228c5b7ecad678.svg";
export { ForwardRef as ReactComponent };